import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "ref-list" }
const _hoisted_2 = {
  key: 0,
  class: "muted"
}
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "surface font-greek" }
const _hoisted_5 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_OriginBadge = _resolveComponent("OriginBadge")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.rows.length && _ctx.loading)
      ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Loading…"))
      : _createCommentVNode("", true),
    _createElementVNode("ol", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (r, i) => {
        return (_openBlock(), _createElementBlock("li", {
          key: i,
          class: _normalizeClass({ 'is-unconfirmed': !r.confident })
        }, [
          (r.lemma_id)
            ? (_openBlock(), _createBlock(_component_router_link, {
                key: 0,
                to: `/lemma/${r.lemma_id}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(r.book) + " " + _toDisplayString(r.chapter) + ":" + _toDisplayString(r.verse), 1)
                ]),
                _: 2
              }, 1032, ["to"]))
            : (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(r.book) + " " + _toDisplayString(r.chapter) + ":" + _toDisplayString(r.verse), 1)),
          _createElementVNode("span", _hoisted_4, _toDisplayString(r.surface), 1),
          _createVNode(_component_OriginBadge, {
            origin: r.origin,
            witnesses: r.witnesses,
            "agrees-with-mt": r.agrees_with_mt
          }, null, 8, ["origin", "witnesses", "agrees-with-mt"])
        ], 2))
      }), 128))
    ]),
    (_ctx.rows.length < _ctx.total)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: "plain",
          disabled: _ctx.loading,
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.more && _ctx.more(...args)))
        }, _toDisplayString(_ctx.loading ? 'Loading…' : `${_ctx.total - _ctx.rows.length} more`), 9, _hoisted_5))
      : _createCommentVNode("", true)
  ]))
}